import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const VideoUploadIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="nonzero">
      <path d="M22 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11.586a6.334 6.334 0 0 1-.086-1 6.5 6.5 0 0 1 6.5-6.5c1.51 0 2.896.519 4 1.384V2a2 2 0 0 0-2-2zM10 13V5l6 4-6 4z" />
      <path d="M16 18h3v3h2v-3h3l-4-5z" />
    </g>
  </svg>
);

VideoUploadIcon.propTypes = propTypes;

export default VideoUploadIcon;
